import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import {  useParams } from "react-router-dom";
import { ListaCtaCtePDF } from './ListaCtaCtePDF';
import { fetchConsultaFacturacionAfiliado } from '../../../actions/facturacion/facturasAfiliado';

export const CuponPago = () => {
    const dispatch = useDispatch();
    const { idCupon } = useParams();

    useEffect(() => {
        dispatch( fetchConsultaFacturacionAfiliado(parseInt(idCupon), () => {}) );
      }, [dispatch, idCupon])

    return (
        <>
          <div>
            <ListaCtaCtePDF  numOrdenPago={idCupon}/>
          </div>
        </>
    )
}